<template>
	<div>
		<div class="box-list-tracking right-shadow">
			<div class="content-list-tracking">
				<v-col cols="12" class="px-4 pb-4">
					<div class="text-h6">Detail Ekspedisi</div>
				</v-col>
				<v-divider></v-divider>
				<div class="list-detail-expedition">
					<v-col cols="12" class="px-4">
						<div class="d-flex justify-center">
							<v-icon color="primary lighten-1">mdi-check-circle</v-icon>
							<div class="pl-2 primary--text text--lighten-1 text-h6 text-uppercase">Selesai</div>
						</div>
					</v-col>
					<div>
						<div class="px-3">
							<v-slider loader-height="5" readonly v-model="taskDriver" min="0" max="5" hide-details color="primary lighten-1">
								<template v-slot:append>
									<v-chip color="deep-purple lighten-5" small>
										<div class="font-size-10">5/5</div>
									</v-chip>
								</template>
							</v-slider>
						</div>
						<div class="px-4 pb-2">
							<v-row>
								<v-col cols="12" class="pt-1 pb-1">
									<v-row>
										<v-col cols="5" class="font-size-10 pt-0 pb-1 pr-0">Nomor Ekspedisi</v-col>
										<v-col cols="7" class="font-size-10 pt-0 pb-1 pl-0 d-flex">
											<div>:</div>
											<div class="font-weight-bold pl-2">0002</div>
										</v-col>
										<v-col cols="5" class="font-size-10 pt-0 pb-1 pr-0">Tanggal Berangkat</v-col>
										<v-col cols="7" class="font-size-10 pt-0 pb-1 pl-0 d-flex">
											<div>:</div>
											<div class="font-weight-bold pl-2">30 November 2020 16:10</div>
										</v-col>
										<v-col cols="5" class="font-size-10 pt-0 pb-1 pr-0">Tanggal Selesai</v-col>
										<v-col cols="7" class="font-size-10 pt-0 pb-1 pl-0 d-flex">
											<div>:</div>
											<div class="font-weight-bold pl-2">30 November 2020 23:10</div>
										</v-col>
										<v-col cols="5" class="font-size-10 pt-0 pb-1 pr-0">Jarak Tempuh</v-col>
										<v-col cols="7" class="font-size-10 pt-0 pb-1 pl-0 d-flex">
											<div>:</div>
											<div class="font-weight-bold pl-2">123 Km</div>
										</v-col>
										<v-col cols="5" class="font-size-10 pt-0 pb-1 pr-0">Waktu Tempuh</v-col>
										<v-col cols="7" class="font-size-10 pt-0 pb-1 pl-0 d-flex">
											<div>:</div>
											<div class="font-weight-bold pl-2">6 Jam 50 Menit</div>
										</v-col>
										<v-col cols="5" class="font-size-10 pt-0 pb-1 pr-0">Jumlah Ekspedisi</v-col>
										<v-col cols="7" class="font-size-10 pt-0 pb-1 pl-0 d-flex">
											<div>:</div>
											<div class="font-weight-bold pl-2">5 Ekspedisi</div>
										</v-col>
										<v-col cols="5" class="font-size-10 pt-0 pb-1 pr-0">Jumlah Muatan</v-col>
										<v-col cols="7" class="font-size-10 pt-0 pb-1 pl-0 d-flex">
											<div>:</div>
											<div class="font-weight-bold pl-2">235</div>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
							<v-row>
								<v-col cols="12">
									<v-card elevation="3" class="pa-3 rounded-lg">
										<v-row>
											<v-col cols="6" class="py-0 border-right border-grey text-center">
												<div class="font-size-10 grey--text font-weight-bold">Km Awal</div>
												<div class="pt-1 font-weight-bold">235 Km</div>
											</v-col>
											<v-col cols="6" class="py-0 text-center">
												<div class="font-size-10 grey--text font-weight-bold">Km Akhir</div>
												<div class="pt-1 font-weight-bold">352 Km</div>
											</v-col>
										</v-row>
									</v-card>
								</v-col>
								<v-col cols="12" class="pt-1">
									<v-card elevation="3" class="pa-3 rounded-lg">
										<v-row>
											<v-col cols="6" class="py-0 border-right border-grey text-center">
												<div class="font-size-10 grey--text font-weight-bold">Bbm Awal</div>
												<div class="pt-1 font-weight-bold">1/2 Tangki</div>
											</v-col>
											<v-col cols="6" class="py-0 text-center">
												<div class="font-size-10 grey--text font-weight-bold">Bbm Akhir</div>
												<div class="pt-1 font-weight-bold">3/4 Tangki</div>
											</v-col>
										</v-row>
									</v-card>
								</v-col>
								<v-col cols="12" class="pt-1">
									<v-card elevation="3" class="pa-3 rounded-lg">
										<v-row>
											<v-col cols="6" class="py-0 border-right border-grey text-center">
												<div class="font-size-10 grey--text font-weight-bold">Saldo Awal</div>
												<div class="pt-1 teal--text font-weight-bold">Rp 300.000</div>
											</v-col>
											<v-col cols="6" class="py-0 text-center">
												<div class="font-size-10 grey--text font-weight-bold">Realisasi</div>
												<div class="pt-1 pink--text font-weight-bold">Rp 200.000</div>
											</v-col>
										</v-row>
									</v-card>
								</v-col>
							</v-row>
						</div>
					</div>
				</div>
				<v-divider></v-divider>
			</div>
		</div>
		<Information></Information>
		<DetailDelivery></DetailDelivery>
	</div>
</template>

<script>
import Information from './Information'
import DetailDelivery from './DetailDelivery'

export default {
	components: {
		Information, DetailDelivery
	},
	data () {
		return {
			taskDriver: 5,
		}
	},
	methods: {
		
	},
	created() {
		this.$store.dispatch('setPageTitle', `Laporan Ekspedisi`)
	}
};
</script>